module.exports = __webpack_public_path__ + "static/media/canada2.991bbe8c.jpg";